import { NewRequestPageQuery } from 'generated/resources/graphql'

interface GetCurrenciesResult {
  currencies: { isoCode: string }[]
  userCurrency: string
}

export function getCurrencies(newRequestPageData?: NewRequestPageQuery): GetCurrenciesResult {
  const currencies =
    newRequestPageData?.apiCore?.currenciesConnection?.edges?.map((edge) => edge.node) || []

  const userCurrency =
    newRequestPageData?.apiCore?.currentsConnection?.nodes?.[0]?.employee?.legalEntity?.currency ||
    ''

  return { currencies, userCurrency }
}
